// 课程数据存储
const state = {
    defaultCourseCover:[ //默认课程cover图片
       `this.src="${require("@/assets/course/course-cover01.jpg")}"`,
       `this.src="${require("@/assets/course/course-cover02.jpg")}"`,
       `this.src="${require("@/assets/course/course-cover03.jpg")}"`,
       `this.src="${require("@/assets/course/course-cover04.jpg")}"`,
       `this.src="${require("@/assets/course/course-cover05.jpg")}"`,
    ],
    
};
  
const mutations = {
};

export default {
  state,
  mutations
}